import { useState, useRef, useEffect } from 'react';
import type { Suggestion } from './LiliAsyncAutoComplete';

export const useAsyncAutoCompleteLogic = (
  selectedSuggestion?: Suggestion | null,
  displayValue?: string
) => {
  const [searchValue, setSearchValue] = useState<string>(
    displayValue ?? selectedSuggestion?.title ?? ''
  );

  useEffect(() => {
    if (displayValue !== undefined) {
      setSearchValue(displayValue);
    } else {
      setSearchValue(selectedSuggestion?.title ?? '');
    }
  }, [displayValue, selectedSuggestion]);
  const firstItemRef = useRef<HTMLDivElement>(null);
  const lastItemRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const observerRef = useRef<IntersectionObserver | null>(null);

  return {
    searchValue,
    firstItemRef,
    lastItemRef,
    observerRef,
    setSearchValue,
    inputRef,
  };
};
